import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Layout from '../layout/index.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/User',
    component: Layout,
    children: [{
      path: '/',
      name: 'User',
      meta: { 
        title: '用户管理',
        requiresAuth: true
      },
      component: () => import('@/views/User/index.vue'),
    }]
  },
  {
    path: '/Subscription',
    component: Layout,
    children: [{
      path: '/',
      name: 'Subscription',
      meta: { 
        title: '订阅管理',
        requiresAuth: true
      },
      component: () => import('@/views/Subscription/index.vue'),
    }]
  },
  {
    path: '/Subscription/Add',
    component: Layout,
    children: [{
      path: '/',
      name: 'AddSubscription',
      meta: { 
        title: '新增订阅',
        requiresAuth: true
      },
      component: () => import('@/views/Subscription/AddSubscription.vue'),
    }]
  },
  {
    path: '/Subscription/New',
    component: Layout,
    children: [{
      path: '/',
      name: 'NewSubscription',
      meta: { 
        title: '新增订阅',
        requiresAuth: true
      },
      component: () => import('@/views/Subscription/NewSubscription.vue'),
    }]
  },
  {
    path: '/Subscription/New/:taskid',
    component: Layout,
    children: [{
      path: '/',
      name: 'NewSKU',
      meta: { 
        title: '新增订阅',
        requiresAuth: true
      },
      component: () => import('@/views/Subscription/NewSKU.vue'),
    }]
  },
  {
    path: '/ProductInfo/:subid/PO/:poid',
    component: Layout,
    children: [{
      path: '/',
      name: 'ProductInfoList',
      meta: { 
        title: '标准信息表',
        requiresAuth: true
      },
      component: () => import('@/views/Subscription/ProductInfo.vue'),
    }]
  },
  {
    path: '/Brand',
    component: Layout,
    children: [{
      path: '/',
      name: 'Brand',
      meta: { 
        title: '品牌信息管理',
        requiresAuth: true
      },
      component: () => import('@/views/Brand/index.vue'),
    }]
  },
  {
    path: '/FilterConfiguration/:subid',
    component: Layout,
    children: [{
      path: '/',
      name: 'FilterConfiguration',
      meta: { 
        title: '数据过滤规则管理',
        requiresAuth: true
      },
      component: () => import('@/views/Subscription/FilterConfiguration.vue'),
    }]
  },
  {
    path: '/MatchResultConsole/:subid/PO/:poid/SKU/:skuid',
    component: Layout,
    children: [{
      path: '/',
      name: 'MatchResultConsole',
      meta: { 
        title: '商品匹配结果管理',
        requiresAuth: true
      },
      component: () => import('@/views/Subscription/MatchResultConsole.vue'),
    }]
  },
  {
    path: '/SKUURLMatchingManager/:subid/PO/:poid/SKU/:skuid',
    component: Layout,
    children: [{
      path: '/',
      name: 'SKUURLMatchingManager',
      meta: { 
        title: '商品匹配规则管理',
        requiresAuth: true
      },
      component: () => import('@/views/Subscription/SKUURLMatchingManager.vue'),
    }]
  },
  {
    path: '/VerificationResultConsole/:subid',
    component: Layout,
    children: [{
      path: '/',
      name: 'VerificationResultConsole',
      meta: { 
        title: '商品判定结果管理',
        requiresAuth: true
      },
      component: () => import('@/views/Subscription/VerificationResultConsole.vue'),
    }]
  },
  {
    path: '/Search',
    component: Layout,
    children: [{
      path: '/',
      name: 'Search',
      meta: { 
        title: '搜索',
        requiresAuth: true
      },
      component: () => import('@/views/Search.vue'),
    }]
  },
  {
    path: '/Supplier',
    component: Layout,
    children: [{
      path: '/',
      name: 'Supplier',
      meta: { 
        title: '供应商管理',
        requiresAuth: true
      },
      component: () => import('@/views/Supplier/Index.vue'),
    }, {
      path: 'Detail/:Id',
      name: 'SupplierDetail',
      meta: { 
        title: '额度明细',
        requiresAuth: true
      },
      component: () => import('@/views/Supplier/Detail.vue'),
    }]
  },
  {
    path: '/SpotCheck',
    component: Layout,
    children: [{
      path: '/',
      name: 'SpotCheck',
      meta: { 
        title: '数据抽查',
        requiresAuth: true
      },
      component: () => import('@/views/SpotCheck/Index.vue'),
    }]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

/**
 * 路由守卫进程，判断是否登录
 */
router.beforeEach((to, from, next) => {
  const baseTitle = 'BPS后台管理系统'
  document.title = to.meta.title ? `${to.meta.title} - ${baseTitle}` : baseTitle

  const isAuthenticated = localStorage.getItem('token')
  if(to.meta.requiresAuth){
    if(isAuthenticated){
      next()
    } else{
      next('/')
    }
  } else{
    next()
  }
})

export default router
